
import { mapGetters } from "vuex";
import { UserRole } from "~/enums";
import { User } from "~/models/User";

export default {
  data() {
    return {
      clipped: false,
      drawer: true,
      fixed: false,
      accountLoading: false,
      enableIcons: false,

      accountMenuItems: [
        {
          icon: "mdi-account-circle",
          title: "My Account",
          to: "/my-account",
          // to: "/users/{current_user}"
        },
        {
          icon: "mdi-exit-to-app",
          title: "Logout",
          click: function () {
            this.accountLoading = true;
            this.$auth.logout().then(() => {
              this.accountLoading = false;

              document.location.href = "/login";
            });
          }.bind(this),
        },
      ],
      allPrimaryMenuItems: [
        {
          icon: "mdi-puzzle-outline",
          title: "Configurator",
          id: "configurator",
          visibility: ["admin"],
          subItems: [
            {
              icon: "mdi-package-variant-closed",
              title: "Products",
              to: "/products",
            },
            {
              icon: "mdi-puzzle-piece",
              title: "Options",
              to: "/options",
            },
            {
              icon: "mdi-puzzle",
              title: "Option Groups",
              to: "/option-groups",
            },
            {
              icon: "mdi-rule",
              title: "Compatibility Rules",
              to: "/compatibility-rules",
            },
            {
              icon: "mdi-shape-outline",
              title: "Product Lines",
              to: "/product-lines",
            },
            {
              icon: "mdi-tag-outline",
              title: "Attributes",
              to: "/attributes",
            },
            // {
            //   icon: "mdi-tag",
            //   title: "Attribute Options",
            //   to: "/attribute-options",
            // },
            // {
            //   icon: "mdi-puzzle-outline",
            //   title: "Configurable Slots",
            //   to: "/configurable-slots",
            // },
            {
              icon: "mdi-shape-outline",
              title: "Configurable Slot Types",
              to: "/configurable-slot-types",
            },
          ],
        },
        // {
        //   icon: "mdi-cog-outline",
        //   title: "Configurations",
        //   to: "/configurations",
        // },
        {
          icon: "mdi-file-document-outline",
          title: "Quote Requests",
          to: "/quote-requests",
        },
        {
          icon: "mdi-account",
          title: "Customers",
          to: "/users?df__=W3sicCI6InVzZXJfcm9sZSIsIm8iOiJlcXVhbHMiLCJ2IjoiY3VzdG9tZXIifV0%3D",
        },
        {
          icon: "mdi-account",
          title: "All Users",
          to: "/users",
          visibility: ["admin"],
        },
        {
          title: "My Account",
          icon: "mdi-account",
          id: "my-account",
          to: "/my-account",
          subItems: [
            {
              title: "Account Settings",
              id: "account-settings",
              to: "/my-account/profile",
            },
            {
              icon: "mdi-drama-masks",
              title: "Stop Impersonation",
              click: function () {
                this.accountLoading = true;
                User.endSwitchUser().then(() => {
                  this.accountLoading = false;
                  window.location.href = this.$nuxt.$config.baseURL;
                });
              }.bind(this),
              visibility: () => {
                return this.$auth.user.impersonating;
              },
            },
            {
              icon: "mdi-exit-to-app",
              title: "Logout",
              id: "logout",
              click: function () {
                this.accountLoading = true;
                this.$auth.logout().then(() => {
                  this.accountLoading = false;
                  this.$router.push({
                    path: "/login",
                  });
                });
              }.bind(this),
            },
          ],
        },
      ],
      miniVariant: false,
      resendVerificationOpen: false,
      verificationResent: false,
      showMobile: false,
    };
  },
  mounted() {
    if (typeof this.$route.query.debug !== "undefined") {
      this.$config.debug = this.$route.query.debug == "1" ? true : false;
    }
  },
  computed: {
    ...mapGetters("app", ["title"]),

    activePrimaryMenuItems() {
      return this.allPrimaryMenuItems
        .filter((item) => this.showItemForCurUser(item, this.$auth.user))
        .map((item) => {
          if (item.subItems) {
            item.subItems = item.subItems.filter((subItem) =>
              this.showItemForCurUser(subItem, this.$auth.user)
            );
          }
          return item;
        });
    },
    userName() {
      if (!this.$auth.loggedIn) return "";
      return this.$auth.user.first_name;
    },
    showSystemMenu() {
      return this.$auth.user.is_admin;
    },
    mobileMenuItems() {
      return this.activePrimaryMenuItems
        .map((item) => {
          if (item.subItems) {
            return [{ br: true }, ...item.subItems];
          }
          return item;
        })
        .flat();
    },
    menuStyleBreakpoint() {
      if (this.activePrimaryMenuItems.length < 4) {
        return "xsOnly";
      } else if (this.activePrimaryMenuItems.length < 7) {
        return "smAndDown";
      }

      return "mdAndDown";
    },
    desktopMenuClass() {
      return {
        "d-none": this.$vuetify.breakpoint[this.menuStyleBreakpoint],
      };
    },
    mobileMenuClass() {
      return {
        "d-none": !this.desktopMenuClass["d-none"],
      };
    },
  },
  methods: {
    decorateTo(to) {
      if (to && to.indexOf("{current_user}") !== -1) {
        to = to.replace("{current_user}", this.$auth.user.id);
      }
      return to;
    },
    showItemForCurUser: function (item, user) {
      if (!item.visibility) return true;

      if (typeof item.visibility == "function") return item.visibility(user);

      const isNonAdmin = item.visibility.indexOf("nonAdminOnly") !== -1;

      if (user.is_admin) return !isNonAdmin;

      if (user.is_super_user)
        return item.visibility.indexOf("super") !== -1 && !isNonAdmin;

      return (
        item.visibility.indexOf("admin") === -1 &&
        item.visibility.indexOf("super") === -1
      );
    },
  },
};
